export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// /Users/darlacameron/projects/feature-federal-children-shelters-2018-06/node_modules/d3-shape/src/array.js
// module id = null
// module chunks = 